import { createHook, createStore } from 'react-sweet-state';

import actions from './actions';
import type { InlineFieldsState } from './types';

type Actions = typeof actions;

const store = createStore<InlineFieldsState, Actions>({
    actions,
    name: 'forge.custom-fields.inline-fields-state',
    initialState: {},
});

export const useInlineField = createHook(store, {
    selector: (state, fieldId: string) => state[fieldId],
});

export const useInlineFields = createHook(store);
